(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const slow = navigator.connection && ['slow-2g','2g'].includes(navigator.connection.effectiveType);
  if (reduced || slow) return;
  const tiles = document.querySelectorAll('.ugc-tile__video');
  if (!tiles.length || !('IntersectionObserver' in window)) return;
  const loadSrc = (v) => {
    if (v.dataset.loaded) return;
    const mp4 = v.dataset.mp4, webm = v.dataset.webm;
    if (webm) { const s = document.createElement('source'); s.src = webm; s.type = 'video/webm'; v.appendChild(s); }
    if (mp4)  { const s = document.createElement('source'); s.src = mp4;  s.type = 'video/mp4';  v.appendChild(s); }
    v.load();
    v.dataset.loaded = '1';
  };
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      const v = e.target;
      if (e.isIntersecting) { loadSrc(v); v.play().catch(() => {}); }
      else { v.pause(); }
    });
  }, { threshold: 0.5, rootMargin: '50px' });
  tiles.forEach(v => io.observe(v));
  const lb = document.querySelector('[data-ugc-lb]');
  if (!lb) return;
  const lbVideo = lb.querySelector('.ugc-lb__video');
  const lbCaption = lb.querySelector('[data-ugc-caption]');
  const lbTiktok = lb.querySelector('[data-ugc-tiktok]');
  let lastFocused = null;

  const setSources = (mp4, webm) => {
    while (lbVideo.firstChild) lbVideo.removeChild(lbVideo.firstChild);
    if (webm) { const s = document.createElement('source'); s.src = webm; s.type = 'video/webm'; lbVideo.appendChild(s); }
    if (mp4)  { const s = document.createElement('source'); s.src = mp4;  s.type = 'video/mp4';  lbVideo.appendChild(s); }
    lbVideo.load();
  };

  const openLb = (btn) => {
    lastFocused = btn;
    const mp4 = btn.dataset.fullMp4 || btn.dataset.mp4;
    const webm = btn.dataset.fullWebm || btn.dataset.webm;
    setSources(mp4, webm);
    if (btn.dataset.poster) lbVideo.setAttribute('poster', btn.dataset.poster);
    lbCaption.textContent = btn.dataset.caption || '';
    const tt = btn.dataset.tiktokUrl;
    if (tt && tt !== '#' && tt !== '') {
      lbTiktok.href = tt;
      lbTiktok.hidden = false;
    } else {
      lbTiktok.hidden = true;
    }
    lb.hidden = false;
    document.body.classList.add('ugc-lb-open');
    lbVideo.play().catch(() => {});
    lb.querySelector('.ugc-lb__close').focus();
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'ugc_video_opened',
        ugc_caption: btn.dataset.caption,
        ugc_destination: btn.dataset.tiktokUrl || ''
      });
    }
  };

  const closeLb = () => {
    lb.hidden = true;
    document.body.classList.remove('ugc-lb-open');
    lbVideo.pause();
    lbVideo.removeAttribute('src');
    while (lbVideo.firstChild) lbVideo.removeChild(lbVideo.firstChild);
    lbVideo.load();
    if (lastFocused) lastFocused.focus();
  };

  document.querySelectorAll('[data-ugc-open]').forEach(btn => {
    btn.addEventListener('click', () => openLb(btn));
  });
  lb.querySelectorAll('[data-ugc-close]').forEach(el => {
    el.addEventListener('click', closeLb);
  });
  document.addEventListener('keydown', (e) => {
    if (!lb.hidden && e.key === 'Escape') closeLb();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
